import { render, staticRenderFns } from "./value-confirmation-examples.vue?vue&type=template&id=370bd9ea&"
import script from "./value-confirmation-examples.vue?vue&type=script&lang=ts&"
export * from "./value-confirmation-examples.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports